import { defineStore } from 'pinia'
import { getUserInfo } from '@/services/admin_api'
import { ref } from 'vue'
import { setUser } from '@/utils/cookie_storage'

const useUserStore = defineStore('user', () => {
  // let userInfo = reactive({
  //   id: undefined,
  //   role_id: undefined,
  //   display_name: '',
  //   email: '',
  //   photo_url: '',
  //   sex: 0
  // } as Record<string, any>)
  const userId = ref(undefined)
  const role_id = ref(undefined)
  const display_name = ref('')
  const photo_url = ref('')

  function setUserInfo(userInfoParams: Record<string, any>, callback?: Function) {
    console.log('setUserInfo', userInfoParams)
    role_id.value = userInfoParams.role_id
    userId.value = userInfoParams.id
    display_name.value = userInfoParams.name
    photo_url.value = userInfoParams.photo_url

    setUser(JSON.stringify(userInfoParams))
    callback && callback()
  }

  function actionUserInfo() {
    return getUserInfo().then((res: any) => {
      setUserInfo(res)
    })
  }

  return {
    userId,
    role_id,
    display_name,
    photo_url,
    setUserInfo,
    actionUserInfo
  }
})

export default useUserStore
